import { createAction } from "redux-actions";

export const updateUI = createAction("UPDATE_UI");
export const initiateGetTokenCall = createAction("INITIATE_GET_TOKEN_CALL");

export const enableResendActivation = () => {
  return updateUI({
    key: "otp.resend_activation",
    data: true
  });
};

export const disableResendActivation = () => {
  return updateUI({
    key: "otp.resend_activation",
    data: false
  });
};

export const refreshTokenInProgress = (value = true) => {
  return updateUI({
    key: "token.refresh.is_fetching",
    data: value
  });
};

export const getOMSToken = isInitiated => initiateGetTokenCall(isInitiated);
